import { isNil } from '@lucidlink/tscore';
import { InternalError, SIZEOF_INT64 } from '#common/types';
import { longToBigInt } from '#common/util';
import { CreateSnapshotRequest } from './messages/create';
import { DeleteSnapshotRequest } from './messages/delete';
import { ListSnapshotRequest } from './messages/list';
export class SnapshotProxy {
    client;
    wasmUtils;
    serverSession;
    snapshotsServiceDestinationPath;
    constructor(fsId, client, wasmUtils, serverSession) {
        this.client = client;
        this.wasmUtils = wasmUtils;
        this.serverSession = serverSession;
        this.snapshotsServiceDestinationPath = `/${fsId}/SnapshotService`;
    }
    async create(snapshotLabel) {
        const req = new CreateSnapshotRequest(snapshotLabel, this.snapshotsServiceDestinationPath);
        const res = await this.sendRequest(req);
        return this.toSnapshotList(res.snapshots);
    }
    async list() {
        const req = new ListSnapshotRequest(this.snapshotsServiceDestinationPath);
        const res = await this.sendRequest(req);
        return this.toSnapshotList(res.snapshots);
    }
    async delete(snapshotId) {
        const req = new DeleteSnapshotRequest(snapshotId, this.snapshotsServiceDestinationPath);
        const res = await this.sendRequest(req);
        return this.toSnapshotList(res.snapshots);
    }
    toSnapshotList(snapshots) {
        return snapshots.map((snapshot) => {
            const versionVector = new DataView(snapshot.version.buffer, snapshot.version.byteOffset, snapshot.version.byteLength);
            if (versionVector.getBigInt64(0, true) !== 1n) {
                throw new InternalError('Version array of snapshot must have a single entry');
            }
            const versionLength = versionVector.byteLength - SIZEOF_INT64;
            const versionBuffer = new Uint8Array(versionVector.buffer, versionVector.byteOffset + SIZEOF_INT64, versionLength);
            const version = this.wasmUtils.deserializeVersion(versionBuffer);
            return {
                id: snapshot.id,
                state: snapshot.state,
                label: snapshot.label,
                version: version,
                creationTime: longToBigInt(snapshot.creationTime),
            };
        });
    }
    async establishSession() {
        if (isNil(this.serverSession)) {
            return undefined;
        }
        return await this.serverSession.getSessionToken();
    }
    async sendRequest(msg) {
        const sessionToken = await this.establishSession();
        return (await this.client.sendRequest(msg, sessionToken));
    }
}
